import { useCallback, useEffect, useMemo, useState } from "react"
import { DetalleRegimenUnidad } from "./typeHistoricoUnidadesHE";
import { historicoMovUnidades, ObtenerReporteDetalladoEjecucionPHE, ObtenerReporteExcelEjecucionPHE } from "../Historial Solicitudes/FunctionsHistorialSolicitudes";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import React from "react";
import { Button, Table } from "react-bootstrap";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label } from "reactstrap";
import Cargando from "components/Varios/Cargando";
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg";
import ModalCargando from "components/Varios/ModalCargando";
import { GetNumberFormatHE } from "../Proyeccion Horas Extras/TablaUnidadesProyeccionHE";
import ModalConfirmacion from "components/Varios/Modals/ModalConfirmacion";
import DatePickerBlueColor from "components/Varios/DatePicker/DatePickerBlueColor";
import MonthDatePicker from "components/Varios/DatePicker/MonthDatePicker";

export function EjecucionPresupuestaria() {

    const [unidadesHisto, setunidadesHisto] = useState<DetalleRegimenUnidad[]>([]);
    const [loading, setloading] = useState<boolean>(false);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);

    const [openModal, setopenModal] = useState<boolean>(false);
    const [desdefecha, setdesdefecha] = useState<Date | null>(null);
    const [hastafecha, sethastafecha] = useState<Date | null>(null);

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        getUnidadesHistorico();
    }, [])

    async function getUnidadesHistorico() {
        setloading(true)
        const respuestaUnidades = await historicoMovUnidades();
        if (respuestaUnidades.status == 200 && respuestaUnidades.dataResponse) {
            setunidadesHisto(respuestaUnidades.dataResponse)
        }
        else {
            showAlert("ha ocurrido un inconveniente al consultar la información", false);
        }
        setloading(false)
    }

    async function ReporteExcel() {
        setloadingAccion(true);
        const reporteExcel = await ObtenerReporteExcelEjecucionPHE();
        if (reporteExcel.status == 200) {
            console.log("Success");
        }
        else {
            showAlert("Ocurrio un inconveniente al cargar datos", false);
        }

        setloadingAccion(false);
    }

    async function ReporteDetalladoExcel(desde: Date | null, hasta: Date | null) {
        setloadingAccion(true);
        if (desde && hasta) {
            if (desde.getFullYear() !== hasta.getFullYear()) {
                showAlert("Las fechas seleccionadas deben corresponder al mismo año", false);
                setloadingAccion(false);
                return -1;
            }
            const desdeFormato = `${desde.getFullYear()}-${String(desde.getMonth() + 1).padStart(2, '0')}-${String(desde.getDate()).padStart(2, '0')}`;
            const hastaFormato = `${hasta.getFullYear()}-${String(hasta.getMonth() + 1).padStart(2, '0')}-${String(hasta.getDate()).padStart(2, '0')}`;

            const reporteExcel = await ObtenerReporteDetalladoEjecucionPHE(desdeFormato, hastaFormato);
            if (reporteExcel.status == 200) {
                console.log("Success");
            }
            else {
                showAlert("Ocurrio un inconveniente al cargar datos", false);
                setloadingAccion(false);
                return -1;
            }
        }
        setloadingAccion(false);
        return 1;
    }

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    //reorganiza ascendente o descendente los nombres
    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }
                return 0;
            });
            return sortedData;
        }
    };


    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = (unidadesHisto && unidadesHisto.length > 0) ? unidadesHisto.filter(unid =>
        (unid.nombreUnidad.toLowerCase().includes(searchTerm.toLowerCase()))
    ) : [];

    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const tablaHistorico = useMemo(() => {

        const PresupuestoAsignadoTotal = unidadesHisto.reduce((acc, curr) => {
            return acc + (curr.listadoRegimenLaboralesPlan.presupuestoCodificado ?? 0);
        }, 0);

        const preuspuestoDevengadoTotal = unidadesHisto.reduce((acc, curr) => {
            return acc + ((curr.listadoRegimenLaboralesPlan.devengadoPagado ?? 0) + (curr.listadoRegimenLaboralesPlan.devengadoNoPagado ?? 0));
        }, 0);

        return (
            <React.Fragment>
                <Row>
                    <Col xl={8}>
                    </Col>
                    <Col xl={4}>
                        <div className="d-flex align-items-center justify-content-end">
                            <Button
                                onClick={() => {
                                    setopenModal(true);
                                }}
                                className="btn-Excel">
                                <div className="containerBotonImprimir">
                                    <div>Reporte Detallado</div>
                                    <IconoExcel className="iconBotonImprimir" />
                                </div>
                            </Button>
                            <Button
                                onClick={() => {
                                    ReporteExcel();
                                }}
                                className="btn-Excel">
                                <div className="containerBotonImprimir">
                                    <div>Exportar a Excel</div>
                                    <IconoExcel className="iconBotonImprimir" />
                                </div>
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="4" className="d-flex align-items-center justify-content-start">
                        <div className="d-flex justify-content-center"
                            style={{
                                border: ' 1px solid #243165',
                                borderRadius: '5px',
                                color: '#243165',
                                padding: '8px 16px',
                                minHeight: '40px',
                                //lineHeight: '1.4',
                                textAlign: 'center'
                            }}
                        >
                            Cumplimiento del presupuesto de Horas Extras: {(preuspuestoDevengadoTotal / PresupuestoAsignadoTotal * 100).toFixed(2)}%
                        </div>
                    </Col>
                    <Col xs="3" md="3" className="d-flex align-items-end justify-content-end ml-auto">
                        <Input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="form-control-sm" // Reduce el tamaño del input
                        />
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table className="table_planificacion_he table table-bordered">
                        <thead className="cabeceras_tabla_servidores_act_he">
                            <tr>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> # </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }} onClick={() => handleSort("nombreUnidad")}> Unidad </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> % de Cumplimiento</th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Presupuesto <br /> Asignado </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Presupuesto <br /> Modificado </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Presupuesto <br /> Codificado </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Devengado <br /> Pagado </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Devengado <br /> no Pagado </th>
                                <th colSpan={1} align={"center"} style={{ fontSize: '0.9rem' }}> Presupuesto <br /> por Devengar </th>
                            </tr>
                        </thead>
                        <tbody className="tbodyAprobacionNominaTH">
                            {currentRows.map((cr, i) => {
                                const globalIndex = indexOfFirstRow + i + 1

                                const devengadoTotal = cr.listadoRegimenLaboralesPlan.devengadoPagado + cr.listadoRegimenLaboralesPlan.devengadoNoPagado;
                                const codificado = cr.listadoRegimenLaboralesPlan.presupuestoCodificado;

                                return (
                                    <React.Fragment key={i}>

                                        <tr className=''>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {globalIndex} </td>
                                            <td className="izquierda" style={{ fontSize: '0.9rem' }}> {cr.nombreUnidad} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {(devengadoTotal / codificado * 100).toFixed(2)} % </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.presupuestoAsignado)} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.reformaPresupuestaria)} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.presupuestoCodificado)} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.devengadoPagado)} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.devengadoNoPagado)} </td>
                                            <td className="centrado" style={{ fontSize: '0.9rem' }}> {GetNumberFormatHE(cr.listadoRegimenLaboralesPlan.presupuestoDevengar)} </td>
                                        </tr>

                                    </React.Fragment>
                                )
                            }
                            )}
                        </tbody>
                    </Table>
                    {/* <Pagination size="sm" className="pagination_planificacion_he">
                        {renderPageNumbers}
                    </Pagination> */}
                    <ModalCargando
                        show={loadingAccion != false}
                        textoCargando='Cargando Datos'
                        size='md'
                        onClose={() => setloadingAccion(false)}
                    />
                </div>
            </React.Fragment>
        );

    }, [currentRows])


    const contenidoDetallePresup = useCallback(() => {

        return (
            <div className="align-items-start" style={{ minHeight: 165 }}>
                <div className="subTitulo_blue2">SELECCIONE EL RANGO DE FECHA QUE DESEA CONSULTAR</div>
                <Row className="justify-content-center">
                    <Col xl={4}>
                        <label> Desde: </label>
                        <MonthDatePicker
                            value={desdefecha}
                            color="blue"
                            placeholderText="Desde"
                            onChange={(e) => setdesdefecha(e)}
                            minDate={"2025-01-01"}
                        />
                    </Col>
                    <Col xl={4}>
                        <label>Hasta: </label>
                        <MonthDatePicker
                            value={hastafecha}
                            color="blue"
                            placeholderText="Hasta"
                            onChange={(e) => sethastafecha(e)}
                            minDate={"2025-01-01"}
                        />
                    </Col>
                </Row>
            </div>
        );
    }, [desdefecha, hastafecha])

    return (
        <React.Fragment>
            <div className={"content"}>
                <div style={{ alignContent: 'center' }} className="titulo_seccion"> EJECUCIÓN PRESUPUESTARIA DE HORAS EXTRAS</div>
                <br></br>
                {loading && <Cargando />}
                {!loading && currentRows && (
                    tablaHistorico
                )}
            </div>

            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={!loadingAccion && openModal != false}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='EXPORTAR'
                nombreBotonCerrarModal='CANCELAR'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => setopenModal(false)}
                asyncOnClick={async () => await ReporteDetalladoExcel(desdefecha, hastafecha)}
                contentModal={contenidoDetallePresup()}
                tituloModal={"EXPORTAR EJECUCIÓN PRESUPUESTARIA DETALLADA"}
                useContainer={true}
                classNameContentModal={"align-items-start"}
            />
        </React.Fragment>
    )
}